/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Quotas_No_Unsaved_ChangesInputs */



/**
* | output |
* | --- |
* | "No unsaved changes" |
*
* @param {Sub_Quotas_No_Unsaved_ChangesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_quotas_no_unsaved_changes = /** @type {((inputs?: Sub_Quotas_No_Unsaved_ChangesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Quotas_No_Unsaved_ChangesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine ungespeicherten Änderungen")
	return /** @type {LocalizedString} */ ("No unsaved changes")
});